import api from './client';

/** Добавить задачу в очередь на рассмотрение (по id или номеру). */
export async function addTaskToInbox({
  taskId,
  number,
  lessonSessionId,
  studentId,
  note,
} = {}) {
  const body = {};
  if (taskId != null && taskId !== '') {
    body.task_id = Number(taskId);
  } else if (number != null && String(number).trim()) {
    body.number = String(number).trim();
  }
  if (lessonSessionId != null && lessonSessionId !== '') {
    body.lesson_session_id = Number(lessonSessionId);
  }
  if (studentId != null && studentId !== '') {
    body.student_id = Number(studentId);
  }
  if (note != null) body.note = note;
  const res = await api.post('/teacher/task-inbox/', body);
  return res.data;
}

/** Пометить запись очереди как готовую (снять с очереди). */
export async function markInboxItemDone(itemId) {
  const res = await api.patch(`/teacher/task-inbox/${itemId}/`, { status: 'done' });
  return res.data;
}

/** Есть ли задача в открытой очереди. */
export async function fetchInboxByTask(taskId) {
  const res = await api.get(`/teacher/task-inbox/by-task/${taskId}/`);
  return res.data;
}

/** Задачи с пометкой «проблемы с условием». */
export async function fetchStatementIssues() {
  const res = await api.get('/teacher/ege-bank/statement-issues/');
  return res.data;
}

/** Снять / поставить пометку «проблемы с условием». */
export async function patchStatementIssue(taskId, flagged) {
  const res = await api.patch(`/teacher/ege-bank/tasks/${taskId}/`, {
    ege_statement_issue: Boolean(flagged),
  });
  return res.data;
}
